import * as angular from "angular";
import {DateRangeTimeFiltersService} from "../services/date-range-time-filters.service";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDateRange', bringozDateRange);

function bringozDateRange(splitService, dateRangeTimeFiltersService: DateRangeTimeFiltersService) {
  return function bringozDateRange(range, noNamesJustDates, displayTime) {

    const dateFormat = splitService.getDateAndTimeConfig();

    let from, to;

    if (!range || (
      (!range.from || !range.to) &&
      (!range.notBefore || !range.notAfter) &&
      (!range.startTime || !range.endTime))) {
      return '---'
    }

    from = range.from || range.notBefore || range.startTime;
    to = range.to || range.notAfter || range.endTime;

    return dateRangeTimeFiltersService.getRangeDisplay(from, to, dateFormat, noNamesJustDates, displayTime);
  }
}
